import Login from '@/views/Login.vue';
import GuestLogin from '@/views/GuestLogin.vue';

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/guest-login/:token?',
    name: 'guest.login',
    component: GuestLogin,
  },
];
